export default __webpack_public_path__ + "static/media/tags-1.24f76f70.svg";